module.exports = "<div class=\"div\">\r\n  <div *ngIf=\"flag\" [innerHTML]=\"allData['content']\"></div>\r\n  <div *ngIf=\"!flag\">No Data</div>\r\n</div>\r\n"